// Business Snapshot qualitative Q&A — shown on onboarding when no pitch deck
// is uploaded. Keys are shared with the backend (business_snapshot_qa.answers)
// and the admin business-detail view.
export const BUSINESS_SNAPSHOT_QUESTIONS = [
  {
    key: "what_you_do",
    label: "What does your business do, and what products or services do you sell?",
    helper: "Tell us in your own words — what problem do you solve, what do you offer, and who benefits from it?",
  },
  {
    key: "sales_channels",
    label: "How and where do you sell, and where do most of your sales come from?",
    helper: "For example: a physical shop in Nairobi, an e-commerce platform, field agents, WhatsApp orders, or a mix. Tell us what drives the most revenue.",
  },
  {
    key: "customers",
    label: "Who are your customers, and what does a typical customer look like?",
    helper: "Are they individuals, businesses, institutions, or government? Describe who buys from you most and why they come to you.",
  },
  {
    key: "customer_acquisition",
    label: "How do you find and win new customers?",
    helper: "Walk us through how a new customer discovers you and decides to buy — for example: referrals, social media, a sales team, tenders, partnerships, or word of mouth.",
  },
  {
    key: "team",
    label: "How big is your team and what are the key roles?",
    helper: "Tell us how many people work in the business and what the main functions are — for example: founders, sales, operations, finance, tech.",
  },
  {
    key: "operations",
    label: "How do you manage your business operations day to day?",
    helper: "Do you use any software or technology tools? For example: accounting software, an ERP, a CRM, an inventory system, a delivery app, or any platform that helps you run the business.",
  },
  {
    key: "revenue_model",
    label: "How does your business make money, and how consistent is that income?",
    helper: "Describe your revenue model — do you charge per sale, subscription, retainer, commission, or project fee? Is revenue steady month to month or does it come in peaks and troughs?",
  },
];
